const endpointName = 'Camps';
const Endpoints = {
  /**
   * @description getting a specific camp
   * @param supplierCode {string} = supplier code of the camp
   * @returns a promise
   */
  getCamp: function(supplierCode) {
    const filter = { include: { relation: 'region', scope: { include: 'country' } } };
    return this.get(`/api/${endpointName}/${supplierCode}?filter=${JSON.stringify(filter)}`);
  },
  /**
   * @description get the camp info for a specific camp
   * @param {string} id = camp
   * @param {string} locale = locale of the user
   * @returns a promise
   */
  getCampInfo: function(id, locale) {
    return this.get(`/api/${endpointName}/${id}/camp-info${locale ? `?locale=${locale}` : ''}`);
  },
  /**
   * @description get the accommodation info for a specific camp
   * @param {string} id = camp
   * @param {string} locale = locale of the user
   * @returns a promise
   */
  getAccommodationInfo: function(id, locale) {
    return this.get(`/api/${endpointName}/${id}/accommodation-info${locale ? `?locale=${locale}` : ''}`);
  },
};

export default Endpoints;
